export default "__VITE_ASSET__D60owHZR__"